<template>
  <div class="contact">
    <!-- title -->
    <el-row>
      <el-col :span="24" :xs="24" class="contact-title">
        {{ $t("contact-review-title") }}</el-col
      >
    </el-row>
    <el-divider />
    <div class="contact-content">
      <!-- title2 -->
      <el-row>
        <el-col :span="24" :xs="24" class="contact-title2">
          {{ $t("contact-review-title2") }}</el-col
        >
      </el-row>
      <el-row>
        <el-col :span="24" :xs="24" class="contact-title2">
          {{ $t("contact-review-title3") }}</el-col
        >
      </el-row>
      <el-divider />
      <!-- 氏名 -->
      <el-row>
        <el-col :span="6" :xs="6" class="contact-field">
          {{ $t("contact-name") }}</el-col
        >
        <el-col :span="18" :xs="18" class="">
          <el-input
            v-model="contactInfo.name"
            class="contact-input"
            size="large"
            disabled
          />
        </el-col>
      </el-row>
      <el-divider />
      <!-- E-mail -->
      <el-row>
        <el-col :span="6" :xs="6" class="contact-field">
          {{ $t("contact-email") }}</el-col
        >
        <el-col :span="18" :xs="18" class="">
          <el-input
            v-model="contactInfo.mail"
            class="contact-input"
            size="large"
            disabled
          />
        </el-col>
      </el-row>
      <el-divider />
      <!-- お問い合わせ内容 -->
      <el-row>
        <el-col :span="6" :xs="6" class="contact-field">
          {{ $t("contact-content") }}</el-col
        >
        <el-col :span="18" :xs="18" class="">
          <el-input
            v-model="contactInfo.content"
            class="contact-input"
            size="large"
            maxlength="500"
            show-word-limit
            type="textarea"
            :rows="8"
            disabled
          />
        </el-col>
      </el-row>
      <el-divider />
      <el-row justify="center">
        <el-button size="large" class="contact-goback-btn" @click="goback()">{{
          $t("contact-review-goback-btn")
        }}</el-button>
        <el-button size="large" class="contact-btn" @click="send()">{{
          $t("contact-review-btn")
        }}</el-button>
      </el-row>
    </div>
    <el-dialog
      v-model="centerDialogVisible"
      title="Warning"
      width="500"
      align-center
    >
      <span>Open the dialog from the center from the screen</span>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="centerDialogVisible = false">Cancel</el-button>
          <el-button type="primary" @click="centerDialogVisible = false">
            Confirm
          </el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ref, onMounted, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import { useI18n } from "vue-i18n";
// import { formatYearMonthDay2 } from "@/utils/utils.js";
import emailjs from "emailjs-com";



export default {
  setup() {
    const router = useRouter();
    // 使用 useRoute 获取路由对象
    const route = useRoute();
    const { t } = useI18n();
    //
    const contactInfo = ref({});

    // const mailTo = ref("");

    const goback = () => {
      localStorage.setItem("contactInfoFrom", "contactInfoReview");
      router.back(); // 返回上一个页面
    };
    const send = async () => {
      // await getContactInfo();

      const serviceID = "service_ndam8i4"; // 你的 Service ID
      const templateID = "template_q6e5l56"; // 你的 Template ID
      const userID = "STkYiPNUD0FTDMHLX"; // 你的 Public Key
      const templateParams = {
        name: contactInfo.value.name,
        email: contactInfo.value.mail,
        subject: "["+generateManagementNumber()+"]お客様の問い合わせ",
        message: contactInfo.value.content,
      };
      console.log("templateParams:"+templateParams);
      emailjs
        .send(serviceID, templateID, templateParams, userID)
        .then((response) => {
          ElMessage({
            message: t("success-message"),
            type: "success",
          });
          localStorage.removeItem("contactInfo");
          localStorage.removeItem("contactInfoFrom");
          router.back(); // 返回上一个页面
        })
        .catch((error) => {
          ElMessage({
            message: "send error",
            type: "error",
          });
        });
    };

    const generateManagementNumber = () => {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const day = String(now.getDate()).padStart(2, "0");
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");
      const seconds = String(now.getSeconds()).padStart(2, "0");

      return `${year}${month}${day}${hours}${minutes}${seconds}`;
    };

    onMounted(() => {
      // 获取 query 参数
      contactInfo.value = route.query;
    });
    return {
      contactInfo,
      goback,
      send,
    };
  },
};
</script>

<style scoped>
.contact {
  padding: 0 50px;
  background: white;
  height: 200%;
}
.contact-title {
  text-align: left;
  font-size: 50px;
  padding: 30px;
  padding-top: 60px;
}
.contact-title2 {
  text-align: left;
  padding: 10px;
}
.contact-content {
  padding: 0 200px;
  padding-bottom: 40px;
}
.contact-input {
  width: 340px;
}
.contact-field {
  font-weight: bold;
  line-height: 40px;
}
.contact-btn {
  height: 50px;
  width: 200px;
  background-color: #1a5276;
  color: white;
}
.contact-goback-btn {
  height: 50px;
  width: 200px;
  background-color: #909399;
  color: white;
}

.contact-btn:hover {
  background-color: #56abe4;
  color: white;
}
@media (max-width: 768px) {
  .contact {
    padding: 20px 20px 0px 20px;
    background: white;
    height: 170%;
  }
  .contact-title {
    text-align: left;
    font-size: 30px;
    padding: 20px;
  }
  .contact-title {
    text-align: left;
    padding: 10px;
  }
  .contact-content {
    padding: 0 20px;
    padding-bottom: 20px;
  }
  .contact-input {
    width: 220px;
  }
  .contact-btn {
    height: 50px;
    width: 130px;
    background-color: #1a5276;
    color: white;
  }
  .contact-goback-btn {
    height: 50px;
    width: 130px;
    background-color: #909399;
    color: white;
  }
}
</style>
